<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="#"><i class="fas fa-chair"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Restaurant v2</span></li>
                <li><span class="text-muted">Mesas</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                <button class="btn btn-custom btn-sm mt-2 mr-2" @click.prevent="clickCreate()">
                    <i class="fa fa-plus-circle"></i> Nuevo
                </button>
            </div>
        </div>

        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de mesas</h3>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Salón</th>
                                <th>Mesa</th>
                                <th>Capacidad</th>
                                <th>Estado operativo</th>
                                <th>Activo</th>
                                <th class="text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, index) in records" :key="row.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ row.room ? row.room.name : '' }}</td>
                                <td>{{ row.name }}</td>
                                <td>{{ row.capacity }}</td>
                                <td>{{ getStatusDescription(row.status) }}</td>
                                <td>
                                    <el-tag :type="row.active ? 'success' : 'info'">
                                        {{ row.active ? 'Activo' : 'Inactivo' }}
                                    </el-tag>
                                </td>
                                <td class="text-right">
                                    <button class="btn btn-xs btn-info" @click.prevent="clickCreate(row)">
                                        Editar
                                    </button>
                                    <button class="btn btn-xs btn-danger" @click.prevent="clickDelete(row.id)">
                                        Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <dining-table-form
            :showDialog.sync="showDialog"
            :record="record"
            @saved="getRecords">
        </dining-table-form>
    </div>
</template>

<script>
import { deletable } from '@mixins/deletable'
import DiningTableForm from './form.vue'

export default {
    mixins: [deletable],
    components: { DiningTableForm },
    data() {
        return {
            resource: 'restaurant/v2/dining-tables',
            records: [],
            showDialog: false,
            record: null,
            statuses: [
                { id: 'available', description: 'Libre' },
                { id: 'occupied', description: 'Ocupada' },
                { id: 'reserved', description: 'Reservada' },
                { id: 'inactive', description: 'Inactiva' },
            ],
        }
    },
    created() {
        this.getRecords()
    },
    methods: {
        getRecords() {
            this.$http.get(`/${this.resource}/records`).then(response => {
                this.records = response.data.data
            })
        },
        getStatusDescription(status) {
            const row = this.statuses.find(x => x.id === status)
            return row ? row.description : status
        },
        clickCreate(record = null) {
            this.record = record
            this.showDialog = true
        },
        clickDelete(id) {
            this.destroy(`/${this.resource}/${id}`).then(() => this.getRecords())
        },
    }
}
</script>


// WEBPACK FOOTER //
// modules/Restaurant/Resources/assets/js/views/v2/dining_tables/index.vue